<table [class]="'animated-table table' + (class ? ' ' + class : '')">
  <thead>
    <tr>
      @for (title of titles; track title; let index = $index) {
        @if (!!title && !!cellProps[index].sortProperty) {
          <th [sortable-column]="cellProps[index].sortProperty" [class]="cellProps[index].class ? cellProps[index].class : ''">
            {{ title | translate }}
          </th>
        }
        @if (!(!!title && !!cellProps[index].sortProperty)) {
          <th [class]="cellProps[index].class ? cellProps[index].class : ''">
            {{ title | translate }}
          </th>
        }
      }
    </tr>
  </thead>
  <tbody>
    @for (item of items; track item) {
      <tr>
        @for (cell of cellProps; track cell; let index = $index) {
          @if (!cell.hidden) {
            @switch (typeResolver(cell, item)) {
              @case (cellTypes.link) {
                <td [class]="classResolver(cell, item) + ' cell-link-block' + (iconResolver(cell, item) ? ' text-nowrap' : '')">
                  <a [href]="hrefurl($event, item, index)" (click)="clickHandler($event, item, index)">
                    @if (iconResolver(cell, item)) {
                      <i [class]="'now-ui-icons ' + iconResolver(cell, item)"></i>
                    }
                    {{ cell.text ? (cell.text | translate) : resolveData(cell, item) }}
                  </a>
                </td>
              }
              @case (cellTypes.statusIcon) {
                <td [class]="classResolver(cell, item).replace('{value}',resolveData(cell, item))"><span></span></td>
              }
              @default {
                <td [innerHtml]="cell.text ? (cell.text | translate) : resolveData(cell, item)" [class]="classResolver(cell, item)"></td>
              }
            }
          }
        }
      </tr>
    }
  </tbody>
  <tfoot>
    <tr>
      @for (cell of cellProps; track cell; let index = $index) {
        @if (!cell.footerResolver) {
          <td></td>
        }
        @if (cell.footerResolver) {
          <td [class]="classResolver(cell, item)">
            {{ footerResolver(cell, items) }}
          </td>
        }
      }
    </tr>
  </tfoot>
</table>
@if (items && !items.length) {
  <p class="mt-4">
    {{ 'No result' | translate }}
  </p>
}